import React, { createContext, ReactNode, useState } from 'react'

interface NavBarContextValue {
  classes: {
    navbar_opened: boolean
    navbar_padding_left: string
    navbar_arrow_margin: string
    navbar_width: string
  }
  setClasses: React.Dispatch<
    React.SetStateAction<{
      navbar_opened: boolean
      navbar_padding_left: string
      navbar_arrow_margin: string
      navbar_width: string
    }>
  >
}

export const NavBarCollapsableContext = createContext<NavBarContextValue>({
  classes: {
    navbar_opened: true,
    navbar_padding_left: 'navbar-open-padding-left',
    navbar_arrow_margin: 'navbar-arrow-open-margin',
    navbar_width: 'navbar-open-width',
  },
  setClasses: () => {}, // Proporciona una función vacía como valor predeterminado
})

export const NavBarContextProvider = ({
  children,
}: {
  children: ReactNode
}) => {
  const [classes, setClasses] = useState({
    navbar_opened: true,
    navbar_padding_left: 'navbar-open-padding-left',
    navbar_arrow_margin: 'navbar-arrow-open-margin',
    navbar_width: 'navbar-open-width',
  })

  return (
    <NavBarCollapsableContext.Provider value={{ classes, setClasses }}>
      {children}
    </NavBarCollapsableContext.Provider>
  )
}
